import { cn } from "@teral/ui/src/lib/utils";

export const getButtonStyles = (isActive?: boolean, showLoader?: boolean) => {
  return cn(
    "relative flex items-center group text-sm font-medium cursor-pointer justify-start w-full text-left",
    "rounded-md transition-[background-color,color,box-shadow] duration-150 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:transition-colors disabled:cursor-not-allowed",
    "outline-hidden focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-(--focus-ring)",
    isActive
      ? [
          "bg-raised text-gray-12 shadow-[0_0_0_1px_var(--color-grayA-4),var(--elevation-xs)] [&_svg]:text-accent-11",
          "dark:bg-grayA-4 dark:shadow-[inset_0_1px_0_oklch(1_0_0/0.05),0_0_0_1px_var(--color-grayA-3)]",
        ]
      : "text-gray-11 hover:bg-grayA-3 hover:text-gray-12 [&_svg]:text-gray-9 hover:[&_svg]:text-gray-11",
    showLoader ? "bg-grayA-3 [&_svg]:text-gray-12" : "",
  );
};
